import AuthLayout from "@/components/AuthLayout"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"

interface Props {
  alert: string | null
  notice: string | null
}

function getCsrfToken() {
  return document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content ?? ""
}

export default function LoginPage({ alert, notice }: Props) {
  return (
    <AuthLayout
      title="Bienvenido de vuelta"
      subtitle="Ingresa tus credenciales para acceder a tu cuenta"
      alert={alert}
      notice={notice}
    >
      <form method="post" action="/session" className="flex flex-col gap-6">
        <input type="hidden" name="authenticity_token" value={getCsrfToken()} />

        <div className="flex flex-col gap-3">
          <Label htmlFor="email">Correo electrónico</Label>
          <Input
            id="email"
            name="email"
            type="email"
            autoComplete="username"
            autoFocus
            required
            placeholder="correo@ejemplo.com"
          />
        </div>

        <div className="flex flex-col gap-3">
          <div className="flex items-center">
            <Label htmlFor="password">Contraseña</Label>
            <a
              href="/passwords/new"
              className="ml-auto text-sm underline-offset-4 hover:underline"
              tabIndex={-1}
            >
              ¿Olvidaste tu contraseña?
            </a>
          </div>
          <Input
            id="password"
            name="password"
            type="password"
            autoComplete="current-password"
            required
            maxLength={72}
            placeholder="••••••••"
          />
        </div>

        <Button type="submit" className="w-full">
          Iniciar sesión
        </Button>
      </form>
    </AuthLayout>
  )
}
